import { ExportTrainingsDataDocument } from 'generated/resources/graphql'

import { useQuery } from 'modules/core/hooks/useQuery'

import { ExportTrainings as ExportTrainingsComponent } from 'modules/trainings/components/ExportTrainings'

const ExportTrainings = () => {
  const { data, loading } = useQuery(ExportTrainingsDataDocument)

  return (
    <ExportTrainingsComponent
      loading={loading}
      teams={data?.teams.teams ?? []}
      trainings={data?.trainings.trainings ?? []}
    />
  )
}

export default ExportTrainings
